// Only allow removing an exercise from a superset if there are more than 2 exercises in the superset

import { WorkoutSuperset } from '@strength/domain-workout';

// because otherwise the superset would only have one exercise
export function canRemoveExerciseFromSuperset(
  superset: WorkoutSuperset,
): boolean {
  return superset.exercises.length > 2;
}
